import type { QuickStartGuideSection } from '@efdigital/ll-xceed-v2/data/coaching/coachee/quick-start-guide';
import type { TOC } from '@ember/component/template-only';

import QuickStartGuideSectionContent from './quick-start-guide-section-content.gts';

interface QuickStartGuideSectionsSignature {
  Args: {
    sections: QuickStartGuideSection[];
  };
  Element: HTMLDivElement;
}

/** True for every section except the last, to draw the divider between items. */
function notLast(index: number, total: number): boolean {
  return index < total - 1;
}

const QuickStartGuideSections: TOC<QuickStartGuideSectionsSignature> =
  <template>
    <div class="card border shadow-sm rounded-4 overflow-hidden" ...attributes>
      <div
        class="accordion accordion-flush quick-start-guide-accordion"
        id="quickStartGuideAccordion"
      >
        {{#each @sections as |section index|}}
          <div
            class="accordion-item border-0 bg-transparent
              {{if (notLast index @sections.length) 'border-bottom'}}"
          >
            <h2 class="accordion-header" id="{{section.id}}-heading">
              <button
                class="accordion-button collapsed fw-semibold p-4 shadow-none d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#{{section.id}}-panel"
                aria-expanded="false"
                aria-controls="{{section.id}}-panel"
              >
                <span
                  class="ll-avatar-xs rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center flex-shrink-0"
                  aria-hidden="true"
                >
                  <iconify-icon inline icon={{section.icon}} class="fs-6" />
                </span>
                <span class="min-w-0">{{section.title}}</span>
              </button>
            </h2>
            <div
              id="{{section.id}}-panel"
              class="accordion-collapse collapse"
              aria-labelledby="{{section.id}}-heading"
              data-bs-parent="#quickStartGuideAccordion"
            >
              <div class="accordion-body px-4 pt-3 pb-4">
                <QuickStartGuideSectionContent @section={{section}} />
              </div>
            </div>
          </div>
        {{/each}}
      </div>
    </div>
  </template>;

export default QuickStartGuideSections;
